export default __webpack_public_path__ + "static/media/card-background-green.3d768dc9.svg";